module.exports = __webpack_public_path__ + "static/Chapter-Regular-9885e57de118303f093fc90e5f95c05e.eot";